<template>
  <footer class="ignore-footer-component">
    <div class="footer-wrapper">
      <div class="footer-item about-us" @click="$router.push({name: 'aboutUs'})">关于我们</div>
      <div class="footer-item">市场合作：gfhcapp@qq.com</div>
      <div class="footer-item">公司地址：深圳市宝安区石岩街道浪心社区青年西路17号松石苑1903</div>
      <div class="footer-item">版权所有：众行融资租赁（深圳）有限公司</div>
      <div class="footer-item">
        <a href="https://beian.miit.gov.cn/" target="_blank" style="color: grey; text-decoration: none;">备 案 号 ：{{ $root.copyright }}</a>
      </div>
      <div class="code-board">
<!--        <div class="about-us-qrcode">-->
<!--          <img :src="appCode" alt="APP下载">-->
<!--          <div>功夫好车APP</div>-->
<!--        </div>-->
        <div class="about-us-qrcode">
          <img :src="qrcode" alt="关注二维码">
          <div>关注我们</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// import appCode from '../assets/app-code.png';
import qrcode from '../assets/qrcode_gfhc.jpg';

export default {
  data () {
    return {
      // appCode,
      qrcode
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/var.scss";

.ignore-footer-component {
  background-color: #000;
  padding-top: 50px;
  padding-bottom: 50px;
  margin-top: 40px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  .footer-wrapper {
    width: $content-width;
    margin: 0 auto;
    position: relative;

    .footer-item {
      font-size: 12px;
      color: #808080;
      line-height: 30px;

      &.about-us {
        color: #ccc;
        cursor: pointer;
        font-size: 16px;
        margin-top: 8px;
        margin-bottom: 4px;
      }
    }

    .code-board {
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      text-align: center;
    }

    .about-us-qrcode {
      color: #ccc;
      font-size: 12px;
      margin: 0px 10px;

      img {
        width: 100px;
        height: 100px;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
